class BlogPagination extends window.BAO.CustomElement() {
  currentPage

  paginationLength

  static get requiredEls () {
    return ['article-list']
  }

  constructor () {
    super()
    this.currentPage = parseInt(this.dataset.currentPage)
    this.paginationLength = parseInt(this.dataset.paginationLength)
  }

  setupListeners () {
    super.setupListeners()

    this.onLoadMoreClick = this.onLoadMoreClick.bind(this)

    this.listeners.add(this, 'click', this.onLoadMoreClick)
  }

  async onLoadMoreClick () {
    const nextPageIndex = this.currentPage + 1
    const nextPageHTML = await this.getBlogPage(nextPageIndex)
    const articleCards = this.getArticleCardsFromPageHTML(nextPageHTML)
    this.appendArticleCardsToArticleList(articleCards)
    this.setCurrentPage(nextPageIndex)
    this.toggleLoadMoreButton(articleCards)
  }

  async getBlogPage (page) {
    const fetchURL = `${window.location.pathname}?page=${page}`
    const sectionToReturn = await window.BAO.sectionRenderer.fetchSingle(
      'template-blog',
      fetchURL,
    )
    return sectionToReturn
  }

  getArticleCardsFromPageHTML (pageHTML) {
    const elementToFindArticleCarts = document.createElement('div')
    elementToFindArticleCarts.innerHTML = pageHTML
    const articleCards = elementToFindArticleCarts.querySelectorAll(
      '.art-Cards_Item',
    )
    return articleCards
  }

  appendArticleCardsToArticleList (articleCards) {
    articleCards.forEach(articleCard => {
      this.externalEls['article-list'].element.appendChild(articleCard)
    })
  }

  setCurrentPage (pageIndex) {
    this.currentPage = pageIndex
  }

  checkAllArticlesLoaded (articleCards) {
    if (articleCards.length !== this.paginationLength) return true
    return false
  }

  toggleLoadMoreButton (articleCards) {
    if (this.checkAllArticlesLoaded(articleCards)) {
      this.remove()
    }
  }
}

if (!customElements.get('blog-pagination')) {
  customElements.define('blog-pagination', BlogPagination)
}
